"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFacebookLoginTokenInAddressBar = exports.setUserFromRemote = void 0;
var effects_1 = require("redux-saga/effects");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var FacebookApi_1 = require("@/api/vendor/FacebookApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var LoginApiSaga_1 = require("@/pages/common/sagas/api/LoginApiSaga");
var LoginState_1 = require("@/pages/common/states/LoginState");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
exports.setUserFromRemote = function (user) {
    var _a, email, id, firstname, lastname, salutation, phone, subscribed, from, isConfirmed;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = {
                    email: user.email,
                    id: user.userId,
                    firstname: user.firstName || '',
                    lastname: user.lastName || '',
                    salutation: LoginState_1.Salutation.NONE,
                    phone: user.phone || '',
                    subscribed: user.subscribed || false,
                    from: user.from || '',
                    isConfirmed: user.registerByEmailConfirmed === undefined || user.registerByEmailConfirmed
                        ? true
                        : false,
                }, email = _a.email, id = _a.id, firstname = _a.firstname, lastname = _a.lastname, salutation = _a.salutation, phone = _a.phone, subscribed = _a.subscribed, from = _a.from, isConfirmed = _a.isConfirmed;
                return [4 /*yield*/, effects_1.put(UserAction_1.default.setUser({
                        id: id,
                        email: email,
                        firstname: firstname,
                        lastname: lastname,
                        salutation: salutation,
                        phone: phone,
                        subscribed: subscribed,
                        from: from,
                        isConfirmed: isConfirmed,
                    }))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('login_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'loginSuccess'))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.resumeState())];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
};
exports.checkFacebookLoginTokenInAddressBar = function () {
    var isGuest, token, state, currentLanguageCode, repsonse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 1:
                isGuest = _a.sent();
                if (!isGuest)
                    return [2 /*return*/, false];
                return [4 /*yield*/, effects_1.call(FacebookApi_1.getToken)];
            case 2:
                token = _a.sent();
                if (!token) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.call(FacebookApi_1.removeAllQueryString)];
            case 3:
                state = _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setGlobalLoading(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 5:
                currentLanguageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(LoginApiSaga_1.externalLogin, 'Facebook', token, currentLanguageCode)];
            case 6:
                repsonse = _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setGlobalLoading(false))];
            case 7:
                _a.sent();
                if (!(repsonse && repsonse.data && repsonse.data.user)) return [3 /*break*/, 13];
                if (!state) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState(state))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, effects_1.call(exports.setUserFromRemote, repsonse.data.user)];
            case 10:
                _a.sent();
                if (!state) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.resumeState())];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [2 /*return*/, true];
            case 13:
                if (!(repsonse && repsonse.data.result.message)) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessage(repsonse.data.result.message))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [2 /*return*/, false];
        }
    });
};
